import { Experience } from "@/types/experience.types";
export function normalizeExperience(exp: unknown): Experience {
  if (typeof exp === "string") {
    return {
      role: "",
      company: "",
      isLegacy: true,
      legacyText: exp,
    };
  }
  if (typeof exp === "object" && exp !== null) {
    const e = exp as any;
    return {
      role: e.role ?? "",
      company: e.company ?? "",
      startDate: e.start_date ? new Date(e.start_date) : undefined,
      endDate: e.end_date ? new Date(e.end_date) : undefined,
      isOngoing: e.is_ongoing === true,
      years: e.years ?? 0,
      months: e.months ?? 0,
      isLegacy: false,
    };
  }
  return {
    role: "",
    company: "",
    isLegacy: true,
    legacyText: "",
  };
}